import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { GetPFRCodeTableRow } from '../../../../services/apiTypes';
import { useTranslation } from 'react-i18next';
import {
  TEXT_OVERFLOW_1LINE,
  TEXT_OVERFLOW_2LINES,
  TEXT_OVERFLOW_3LINES,
} from '../../../../_constants/styleConst';
import { isEmptyData } from '../../../../_utils/utils';

type BeforeTableProps = {
  pfrCodeList: {
    before: GetPFRCodeTableRow[];
    after: GetPFRCodeTableRow[];
  };
};

const BeforeTable: React.FC<BeforeTableProps> = ({ pfrCodeList }) => {
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="1%" sx={{ p: '5px' }}></TableCell>
            <TableCell width="20%" sx={{ minWidth: '180px', p: '5px' }}>
              {t('LBL_INSPECTION_CATEGORY')}
            </TableCell>
            <TableCell width="20%" sx={{ minWidth: '180px', p: '5px' }}>
              {t('LBL_INSPECTION_SUB_CATEGORY')}
            </TableCell>
            <TableCell width="20%" sx={{ minWidth: '180px', p: '5px' }}>
              {t('LBL_INSPECTION_ITEM')}
            </TableCell>
            <TableCell
              width="11%"
              sx={{ minWidth: '155px', p: '5px', textAlign: 'center' }}
            >
              {t('LBL_REPORTED_BY_CUSTOMER')}
            </TableCell>
            <TableCell
              width="9%"
              sx={{ minWidth: '100px', pl: '10px', textAlign: 'center' }}
            >
              {t('LBL_CD_CODE')}
            </TableCell>
            <TableCell width="20%" sx={{ minWidth: '200px', pl: '10px' }}>
              {t('LBL_CD_DETAIL')}
            </TableCell>
            <TableCell
              width="9%"
              sx={{ minWidth: '100px', pl: '10px', textAlign: 'center' }}
            >
              {t('LBL_R_CODE')}
            </TableCell>
            <TableCell width="20%" sx={{ minWidth: '200px', pl: '10px' }}>
              {t('LBL_R_DETAIL')}
            </TableCell>
            <TableCell
              width="4%"
              sx={{ minWidth: '100px', p: '5px', textAlign: 'center' }}
            >
              {t('LBL_P_CODE')}
            </TableCell>
            <TableCell width="20%" sx={{ minWidth: '200px', p: '5px' }}>
              {t('LBL_P_DETAIL')}
            </TableCell>
            <TableCell
              width="4%"
              sx={{ minWidth: '100px', p: '5px', textAlign: 'center' }}
            >
              {t('LBL_F_CODE')}
            </TableCell>
            <TableCell width="20%" sx={{ minWidth: '200px', p: '5px' }}>
              {t('LBL_F_DETAIL')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pfrCodeList.before.map((row, i) => {
            const isExists = pfrCodeList.after.some(
              (item) => item.itemId === row.itemId,
            );

            return (
              <TableRow
                key={`before_table_${i}`}
                sx={{
                  pointerEvents: 'none',
                  backgroundColor: isExists ? 'inherit' : 'rgba(255,0,0,0.05)',
                }}
              >
                <TableCell sx={{ p: '5px 5px 5px 29px' }}></TableCell>
                <TableCell sx={{ p: '5px' }}>
                  <Typography sx={TEXT_OVERFLOW_2LINES}>
                    {row.categoryName}
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: '5px' }}>
                  <Typography sx={TEXT_OVERFLOW_2LINES}>
                    {row.typeName}
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{ p: '5px', whiteSpace: 'pre', maxWidth: '300px' }}
                >
                  <Typography sx={TEXT_OVERFLOW_1LINE}>
                    {row.itemName.depth0}
                  </Typography>
                  {!isEmptyData(row.itemName.depth1) && (
                    <Typography sx={TEXT_OVERFLOW_1LINE}>
                      {row.itemName.depth1}
                    </Typography>
                  )}
                  {!isEmptyData(row.itemName.depth2) && (
                    <Typography sx={TEXT_OVERFLOW_1LINE}>
                      {row.itemName.depth2}
                    </Typography>
                  )}
                </TableCell>
                <TableCell sx={{ p: '5px', textAlign: 'center' }}>
                  <Checkbox checked={row.reportedByCustomer} disabled />
                </TableCell>
                <TableCell sx={{ p: '5px', textAlign: 'center' }}>
                  {row.cd.code}
                </TableCell>
                <TableCell sx={{ p: '5px' }}>
                  <Typography sx={TEXT_OVERFLOW_2LINES}>
                    {row.cd.name}
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: '5px', textAlign: 'center' }}>
                  {row.r.code}
                </TableCell>
                <TableCell sx={{ p: '5px' }}>
                  <Typography sx={TEXT_OVERFLOW_3LINES}>
                    {row.r.detail}
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: '5px', textAlign: 'center' }}>
                  {row.p.code}
                </TableCell>
                <TableCell sx={{ p: '5px' }}>
                  <Typography sx={TEXT_OVERFLOW_3LINES}>
                    {row.p.detail}
                  </Typography>
                </TableCell>
                <TableCell sx={{ p: '5px', textAlign: 'center' }}>
                  {row.f.code}
                </TableCell>
                <TableCell sx={{ p: '5px' }}>
                  <Typography sx={TEXT_OVERFLOW_3LINES}>
                    {row.f.detail}
                  </Typography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BeforeTable;
